import React, { useEffect, useState } from "react";
import logo from "./logo.png";
import "./App.css";
import { styled } from "@mui/material/styles";
import skip from "./skip.png";
import { Alert, Button, responsiveFontSizes, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Option from "./components/Options";
import RadionButton from "./components/RadioButton";
// const bg = require("./bg.jpeg");
const skipcashBlue = "#1e3f91";

const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText(skipcashBlue),
  backgroundColor: skipcashBlue,
  color: "white",
  textTransform: "capitalize",
  fontFamily: "Nunito",

  "&:hover": {
    backgroundColor: "white",
    borderColor: skipcashBlue,
    borderWidth: 1,
    borderStyle: "solid",
    color: skipcashBlue,
    textTransform: "capitalize",
    fontFamily: "Nunito",
  },
}));

function App() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [firstName, setFirstName] = useState({
    value: "",
    err: false,
    errTxt: "",
  });
  const [lastName, setLastName] = useState({
    value: "",
    err: false,
    errTxt: "",
  });
  const [option, setOption] = useState({ value: "", err: false, errTxt: "" });
  const [service, setService] = useState({ value: "", err: false, errTxt: "" });
  const [category, setCategory] = useState({
    value: "",
    err: false,
    errTxt: "",
  });
  const [email, setEmail] = useState({ value: "", err: false, errTxt: "" });
  const options = ["Membership", "Sessions"];
  const types = [
    "MEMBERSHIPS",
    "PERSONAL TRAINING PACKAGES",
    "PREMIUM PT PACKAGES",
    "ONE-ON-ONE SWIMMING",
    "SPA TREATMENT - CUPPING",
    "SUMMER OFFER",
  ];
  const ptPackages = [
    "session rate 1 person",
    "session rate 2 people",
    "session rate 3 people",
    "3 months packs",
  ];
  const premiumPackages = [
    "1 Person",
    "2 Persons",
    "3 Persons",
    "4 PERSONS & ABOVE",
  ];
  const memberships = ["DAY PASS", "OPEN GYM", "CLASSES", "GYM + CLASSES"];
  const daypasses = [
    "CLASS OR GYM - 100 QAR",
    "CLASS OR GYM (Corporate) - 90 QAR",
    "ALL ACCESS (GYM & CLASS) - 250 QAR",
    "ALL ACCESS (GYM & CLASS) (Corporate) - 225 QAR",
  ];
  const allaccesses = [
    "1 MONTH * OPEN GYM - 600 QAR",
    "1 MONTH * OPEN GYM (Corporate) - 540 QAR",
    "3 MONTHS * OPEN GYM - 1500 QAR",
    "3 MONTHS * OPEN GYM (Corporate) - 1350 QAR",
  ];
  const classes = [
    "UNLIMITED FOR 1 MONTH - 900 QAR",
    "UNLIMITED FOR 1 MONTH (Corporate) - 810 QAR",
    "UNLIMITED FOR 3 MONTHS - 2500 QAR",
    "UNLIMITED FOR 3 MONTHS (Corporate) - 2250 QAR",
    "FLEXI MEMBERSHIP (10 CLASSES) [valid for 60 days] - 900 QAR",
    "FLEXI MEMBERSHIP (10 CLASSES) [valid for 60 days] (Corporate) - 810 QAR",
    "FLEXI MEMBERSHIP (20 CLASSES) [valid for 90 days] - 1700 QAR",
    "FLEXI MEMBERSHIP (20 CLASSES) [valid for 90 days] (Corporate) - 1530 QAR",
  ];
  const gymclasses = [
    "OPEN GYM + CLASSES - 1350 QAR",
    "OPEN GYM + CLASSES (Corporate) - 1215 QAR",
    "3 MONTHS - 3600 QAR",
    "3 MONTHS (Corporate) - 3240 QAR",
  ];
  const PTPackages = ["1 PERSON", "2 PERSONS", "3 PERSONS"];
  const onePersonPackages = [
    "4 Sessions - 1400 QAR",
    "8 Sessions - 2600 QAR",
    "12 Sessions - 3800 QAR",
    "16 Sessions - 4850 QAR",
    "20 Sessions - 5750 QAR",
  ];
  const twoPersonPackages = [
    "4 Sessions - 2500 QAR",
    "8 Sessions - 4100 QAR",
    "12 Sessions - 5300 QAR",
    "16 Sessions - 6450 QAR",
    "20 Sessions - 7500 QAR",
  ];
  const threePersonPackages = [
    "4 Sessions - 3600 QAR",
    "8 Sessions - 5000 QAR",
    "12 Sessions - 6300 QAR",
    "16 Sessions - 7450 QAR",
    "20 Sessions - 8500 QAR",
  ];
  const onePersonPremiumPackages = [
    "1 Session - 400 QAR",
    "10 Sessions(valid for 45 days) - 3600 QAR",
    "20 Sessions(valid for 3 Months) - 6600 QAR",
    "50 Sessions(valid for 6 Months) - 15750 QAR",
  ];
  const twoPersonPremiumPackages = [
    "1 Session - 550 QAR",
    "10 Sessions(valid for 45 days) - 5000 QAR",
    "20 Sessions(valid for 3 Months) - 9000 QAR",
    "50 Sessions(valid for 6 Months) - 23000 QAR",
  ];
  const thirdPersonPremiumPackages = [
    "1 Session - 600 QAR",
    "10 Sessions(valid for 45 days) - 5500 QAR",
    "20 Sessions(valid for 3 Months) - 9900 QAR",
    "50 Sessions(valid for 6 Months) - 23500 QAR",
  ];
  const fourPersonPremiumPackages = ["1 Session - 150 QAR"];
  const oneToOneSwimming = [
    "1 Session",
    "10 Sessions",
    "AQUA CLASS",
    "10 AQUA CLASSES",
  ];

  const oneSessions = [
    "20 Mins - 130 QAR",
    "30 Mins - 180 QAR",
    "1 Hour - 285 QAR",
  ];
  const tenSessions = [
    "20 Mins - 1150 QAR",
    "20 Mins - 1575 QAR",
    "1 Hour - 2625 QAR",
  ];
  const aquSessions = [
    "20 Mins - 200 QAR",
    "30 Mins - 250 QAR",
    "1 Hour - 325 QAR",
  ];
  const aquTenSessions = [
    "20 Mins - 1850 QAR",
    "30 Mins - 2250 QAR",
    "1 Hour - 2950 QAR",
  ];
  const summerOffers = [
    "8 Sessions - 2199 QAR",
    "16 Sessions - 3800 QAR",
    "20 Sessions - 4850 QAR",
  ];
  const cuppings = ["30 Mins - 300 QAR", "60 Mins - 400 QAR"];
  const mealPlans = [
    "1 PERSON + 1 MEAL PLAN PACK",
    "2 PERSONS + 2 MEAL PLAN PACKS",
    "3 PERSONS + 3 MEAL PLAN PACKS",
    "SMART OPEN GYM ( OPEN GYM + MEAL PLAN )",
    "SMART COM'( CLASSES + MEAL PLAN )",
  ];
  const smartCom = ["SMART OPEN GYM ( OPEN GYM + MEAL PLAN ) - 3000 QAR"];
  const smartopen = ["SMART COM'( CLASSES + MEAL PLAN ) - 3250 QAR"];
  const onePersonMeal = [
    "1 MONTH + 8 SESSIONS - 4790 QAR",
    "1 MONTH + 10 SESSIONS - 5690 QAR",
    "1 MONTH + 8 SESSIONS - 5875 QAR",
  ];
  const twoPersonMeal = [
    "1 MONTH + 8 SESSIONS - 8590 QAR",
    "1 MONTH + 10 SESSIONS - 9390 QAR",
    "1 MONTH + 8 SESSIONS - 9675 QAR",
  ];
  const threePersonMeal = [
    "1 MONTH + 8 SESSIONS - 9390 QAR",
    "1 MONTH + 10 SESSIONS - 12290 QAR",
    "1 MONTH + 8 SESSIONS - 12975 QAR",
  ];
  const [clicked, setClicked] = useState(false);

  const [totalAmount, setTotalAmount] = useState(0);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    // getCurrentNumber();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleData = (value, field, index) => {
    if (field === "firstname") setFirstName({ value, err: false, errTxt: "" });
    else if (field === "lastname")
      setLastName({ value, err: false, errTxt: "" });
    else if (field === "email") setEmail({ value, err: false, errTxt: "" });
    else if (field === "category") {
      setCategory({ value, err: false, errTxt: "" });
      setOption({ value: "", err: false, errTxt: "" });
      setService({ value: "", err: false, errTxt: "" });
      setTotalAmount(0);
    } else if (field === "options") {
      if (category.value === "SPA TREATMENT - CUPPING") {
        // it its cupping then do the calculations here and if not then do the normal set
        let first = value.split("-");
        let second = first[1].split(" ");
        // let third = second[1].split("")
        console.log("the amount : ", second[1]);
        setTotalAmount(second[1]);
        setOption({ value, err: false, errTxt: "" });
        setService({ value, err: false, errTxt: "" });
      }
      if (category.value === "SUMMER OFFER") {
        // it its cupping then do the calculations here and if not then do the normal set
        let first = value.split("-");
        let second = first[1].split(" ");
        // let third = second[1].split("")
        console.log("the amount : ", second[1]);
        setTotalAmount(second[1]);
        setOption({ value, err: false, errTxt: "" });
        setService({ value, err: false, errTxt: "" });
      } else {
        setOption({ value, err: false, errTxt: "" });
      }
    } else if (field === "service") {
      setService({ value, err: false, errTxt: "" });
      let first = value.split("-");
      let second = first[1].split(" ");
      setTotalAmount(second[1]);
    }
    //  {
    //   if (value === "Membership") {
    //     setCategory({ value, err: false, errTxt: "" });
    //   } else if (value === "Sessions") {
    //     setCategory({ value, err: false, errTxt: "" });
    //   }
    //   setOption({ value, err: false, errTxt: "" });
    // }
    else console.log("All good");
  };

  const pay = async () => {
    setClicked(true);
    const nameRegEx = /^[A-Za-z ]+$/;
    const numRegEx = new RegExp("^[0-9]*$");
    if (firstName.value === "") {
      setFirstName({
        value: "",
        err: true,
        errTxt: "First Name cannot be empty",
      });
      setClicked(false);

      return;
    }
    if (!nameRegEx.test(firstName.value)) {
      setFirstName({
        value: "",
        err: true,
        errTxt: "First Name can only have English Letters",
      });
      setClicked(false);
      return;
    }
    if (lastName.value === "") {
      setLastName({
        value: "",
        err: true,
        errTxt: "Last Name cannot be empty",
      });
      setClicked(false);

      return;
    }
    if (email.value === "") {
      setEmail({
        value: "",
        err: true,
        errTxt: "Email cannot be empty",
      });
      setClicked(false);

      return;
    }
    if (!nameRegEx.test(lastName.value)) {
      setLastName({
        value: "",
        err: true,
        errTxt: "Last Name can only have English Letters",
      });
      setClicked(false);
      return;
    }
    if (category.value === "") {
      console.log("inside category");
      alert("Please select a category");
      setClicked(false);

      return;
    }
    if (option.value === "") {
      console.log("inside option");
      alert("Please select an Option");
      setClicked(false);

      return;
    }
    if (service.value === "") {
      console.log("inside service");
      alert("Please select a Service");
      setClicked(false);

      return;
    }

    // alert(amount.value);

    // if (recieve === "") {
    //   alert("Missing or Invalid Details");
    //   setClicked(false);

    //   return;
    // }
    if (totalAmount > 60000) {
      alert("Total Amount Should Be Less than 60000");
      setClicked(false);

      return;
    }
    console.log("category:", category.value);
    console.log("option: ", option.value);
    console.log("service: ", service.value);
    const url = "https://rtb-qatar-8b7a0f2c1609.herokuapp.com/pay";
    //const url = "http://localhost:4000/pay";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        firstName: firstName.value,
        lastName: lastName.value,
        email: email.value,
        amount: totalAmount,
        category: category.value,
        option: option.value,
        service: service.value,
        details: `Category: ${category.value}, Option: ${option.value},  service: ${service.value}`,
      }),
    });
    const json = await response.json();

    window.location = json.payUrl;
  };

  // useEffect(() => {
  //   calculateTotal();
  // }, [flag]);

  // const calculateTotal = () => {
  //   let total = 0;
  //   setCalculated(true);
  //   if (delivery) total = total + 40;
  //   setTotalAmount(total);
  // };

  const styles = {
    container: {
      //backgroundColor: "#242424",
      width: "100%",
      //height: "auto",
      margin: 0,
      display: "flex",
      overflow: "hidden",
      flex: 1,
      flexDirection: "column",
      //minHeight: "100%",
    },
    whiteContainer: {
      display: "flex",
      justifyContent: "center",
      paddingTop: "5%",
      paddingBottom: "5%",
      // height: "100%",sz
      height: "auto",
    },
    mobileButton: {
      width: "100%",
      padding: "5%",
      borderRadius: 10,
      fontStyle: "Quicksand",
      fontSize: "1em",
      height: 40,
    },
    desktopButton: {
      width: "100%",
      padding: "2%",
      borderRadius: 10,
      fontStyle: "Quicksand",
      fontSize: "1.2em",
      height: 20,
    },
    fontSizeStyle: {
      fontFamily: "Quicksand",
      fontSize:
        windowDimensions.width <= 380
          ? "0.75em"
          : windowDimensions.width <= 500
          ? "0.8em"
          : windowDimensions.width > 500 && windowDimensions.width < 600
          ? "1em"
          : windowDimensions.width >= 600 && windowDimensions.width < 1000
          ? "1em"
          : windowDimensions.width < 1500
          ? "1em"
          : "1em",
    },
    fontSizeOptionsStyle: {
      fontFamily: "Quicksand",
      fontSize:
        windowDimensions.width <= 380
          ? "32"
          : windowDimensions.width <= 500
          ? "32"
          : windowDimensions.width > 500 && windowDimensions.width < 600
          ? "32"
          : windowDimensions.width >= 600 && windowDimensions.width < 1000
          ? "32"
          : windowDimensions.width < 1500
          ? "32"
          : "32",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.whiteContainer}>
        <div
          style={{
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "transparent",
            borderRadius: 10,
            width: "90%",
            background: "white",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img src={logo} style={{ height: windowDimensions.height / 4 }} />
          </div>

          <div>
            <div
              style={{
                fontFamily: "Poppins",
                marginLeft: "5%",
                marginRight: "5%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontFamily: "Nunito",
                }}
              >
                <h3>Raise The Bar Gym</h3>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <h3 style={styles.fontSizeStyle}>{`First Name:`}</h3>
                {/* <h3 style={styles.fontSizeStyle}>{`:الاسم `}</h3> */}
              </div>
              <div
                style={{
                  marginTop: "1%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <TextField
                  fullWidth
                  //label="Full Name - الاسم الكامل"
                  id="fullWidth"
                  onChange={(e) => handleData(e.target.value, "firstname")}
                  error={firstName.err}
                  helperText={firstName.errTxt}
                  type="text"
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <h3 style={styles.fontSizeStyle}>{`Last Name:`}</h3>
                {/* <h3 style={styles.fontSizeStyle}>{`:اسم العائلة`}</h3> */}
              </div>
              <div
                style={{
                  marginTop: "1%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <TextField
                  fullWidth
                  //label="Full Name - الاسم الكامل"
                  id="fullWidth"
                  onChange={(e) => handleData(e.target.value, "lastname")}
                  error={lastName.err}
                  helperText={lastName.errTxt}
                  type="text"
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <h3 style={styles.fontSizeStyle}>{`Email Address:`}</h3>
                {/* <h3 style={styles.fontSizeStyle}>{`:البريد الالكتروني`}</h3> */}
              </div>
              <div
                style={{
                  marginTop: "1%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <TextField
                  fullWidth
                  // label="Email Address - البريد الالكتروني"
                  id="fullWidth"
                  onChange={(e) => handleData(e.target.value, "email")}
                  error={email.err}
                  helperText={email.errTxt}
                  type="email"
                />
              </div>

              <h4>Select Category</h4>
              <div
                style={{
                  marginTop: "1%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Option
                  categories={types}
                  handleData={handleData}
                  label={"Category"}
                  fontStyle={styles.fontSizeStyle}
                  field={"category"}
                  fullWidth
                  style={{ width: "48%" }}
                />
              </div>

              {category.value === "MEMBERSHIPS" ? (
                <div>
                  <h4>Select Option</h4>
                  <div
                    style={{
                      marginTop: "1%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Option
                      categories={memberships}
                      handleData={handleData}
                      label={"Membership"}
                      fontStyle={styles.fontSizeOptionsStyle}
                      field={"options"}
                      fullWidth
                      style={{ width: "48%" }}
                    />
                  </div>
                </div>
              ) : category.value === "PERSONAL TRAINING PACKAGES" ? (
                <div>
                  <h4>Select Option</h4>
                  <div
                    style={{
                      marginTop: "1%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Option
                      categories={PTPackages}
                      handleData={handleData}
                      label={"PERSONAL TRAINING PACKAGES"}
                      fontStyle={styles.fontSizeOptionsStyle}
                      field={"options"}
                      fullWidth
                      style={{ width: "48%" }}
                    />
                  </div>
                </div>
              ) : category.value === "PREMIUM PT PACKAGES" ? (
                <div>
                  <h4>Select Option</h4>
                  <div
                    style={{
                      marginTop: "1%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Option
                      categories={premiumPackages}
                      handleData={handleData}
                      label={"PREMIUM PT PACKAGES"}
                      fontStyle={styles.fontSizeOptionsStyle}
                      field={"options"}
                      fullWidth
                      style={{ width: "48%" }}
                    />
                  </div>
                </div>
              ) : category.value === "ONE-ON-ONE SWIMMING" ? (
                <div>
                  <h4>Select Option</h4>
                  <div
                    style={{
                      marginTop: "1%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Option
                      categories={oneToOneSwimming}
                      handleData={handleData}
                      label={"ONE-ON-ONE SWIMMING"}
                      fontStyle={styles.fontSizeOptionsStyle}
                      field={"options"}
                      fullWidth
                      style={{ width: "48%" }}
                    />
                  </div>
                </div>
              ) : category.value === "SPA TREATMENT - CUPPING" ? (
                <div>
                  <h4>Select Option</h4>
                  <div
                    style={{
                      marginTop: "1%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Option
                      categories={cuppings}
                      handleData={handleData}
                      label={"cuppings"}
                      fontStyle={styles.fontSizeOptionsStyle}
                      field={"options"}
                      fullWidth
                      style={{ width: "48%" }}
                    />
                  </div>
                </div>
              ) : category.value === "SUMMER OFFER" ? (
                <div>
                  <h4>Select Option</h4>
                  <div
                    style={{
                      marginTop: "1%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Option
                      categories={summerOffers}
                      handleData={handleData}
                      label={"SUMMER OFFER"}
                      fontStyle={styles.fontSizeOptionsStyle}
                      field={"options"}
                      fullWidth
                      style={{ width: "48%" }}
                    />
                  </div>
                </div>
              ) : null}
              {option.value === "DAY PASS" ? (
                <div>
                  <h4>Select Service</h4>
                  <div
                    style={{
                      marginTop: "1%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Option
                      categories={daypasses}
                      handleData={handleData}
                      label={"Day Pass"}
                      fontStyle={styles.fontSizeOptionsStyle}
                      field={"service"}
                      fullWidth
                      style={{ width: "48%" }}
                    />
                  </div>
                </div>
              ) : option.value === "OPEN GYM" ? (
                <div>
                  <h4>Select Service</h4>
                  <div
                    style={{
                      marginTop: "1%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Option
                      categories={allaccesses}
                      handleData={handleData}
                      label={"OPEN GYM"}
                      fontStyle={styles.fontSizeOptionsStyle}
                      field={"service"}
                      fullWidth
                      style={{ width: "48%" }}
                    />
                  </div>
                </div>
              ) : option.value === "CLASSES" ? (
                <div>
                  <h4>Select Service</h4>
                  <div
                    style={{
                      marginTop: "1%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Option
                      categories={classes}
                      handleData={handleData}
                      label={"CLASSES"}
                      fontStyle={styles.fontSizeOptionsStyle}
                      field={"service"}
                      fullWidth
                      style={{ width: "48%" }}
                    />
                  </div>
                </div>
              ) : option.value === "GYM + CLASSES" ? (
                <div>
                  <h4>Select Service</h4>
                  <div
                    style={{
                      marginTop: "1%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Option
                      categories={gymclasses}
                      handleData={handleData}
                      label={"OPEN GYM"}
                      fontStyle={styles.fontSizeOptionsStyle}
                      field={"service"}
                      fullWidth
                      style={{ width: "48%" }}
                    />
                  </div>
                </div>
              ) : option.value === "1 PERSON" ? (
                <div>
                  <h4>Select Service</h4>
                  <div
                    style={{
                      marginTop: "1%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Option
                      categories={onePersonPackages}
                      handleData={handleData}
                      label={"1 Person"}
                      fontStyle={styles.fontSizeOptionsStyle}
                      field={"service"}
                      fullWidth
                      style={{ width: "48%" }}
                    />
                  </div>
                </div>
              ) : option.value === "2 PERSONS" ? (
                <div>
                  <h4>Select Service</h4>
                  <div
                    style={{
                      marginTop: "1%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Option
                      categories={twoPersonPackages}
                      handleData={handleData}
                      label={"2 Person"}
                      fontStyle={styles.fontSizeOptionsStyle}
                      field={"service"}
                      fullWidth
                      style={{ width: "48%" }}
                    />
                  </div>
                </div>
              ) : option.value === "3 PERSONS" ? (
                <div>
                  <h4>Select Service</h4>
                  <div
                    style={{
                      marginTop: "1%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Option
                      categories={threePersonPackages}
                      handleData={handleData}
                      label={"3 Persons"}
                      fontStyle={styles.fontSizeOptionsStyle}
                      field={"service"}
                      fullWidth
                      style={{ width: "48%" }}
                    />
                  </div>
                </div>
              ) : option.value === "1 Person" ? (
                <div>
                  <h4>Select Service</h4>
                  <div
                    style={{
                      marginTop: "1%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Option
                      categories={onePersonPremiumPackages}
                      handleData={handleData}
                      label={"1 Person"}
                      fontStyle={styles.fontSizeOptionsStyle}
                      field={"service"}
                      fullWidth
                      style={{ width: "48%" }}
                    />
                  </div>
                </div>
              ) : option.value === "2 Persons" ? (
                <div>
                  <h4>Select Service</h4>
                  <div
                    style={{
                      marginTop: "1%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Option
                      categories={twoPersonPremiumPackages}
                      handleData={handleData}
                      label={"2 Persons"}
                      fontStyle={styles.fontSizeOptionsStyle}
                      field={"service"}
                      fullWidth
                      style={{ width: "48%" }}
                    />
                  </div>
                </div>
              ) : option.value === "3 Persons" ? (
                <div>
                  <h4>Select Service</h4>
                  <div
                    style={{
                      marginTop: "1%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Option
                      categories={thirdPersonPremiumPackages}
                      handleData={handleData}
                      label={"3 Persons"}
                      fontStyle={styles.fontSizeOptionsStyle}
                      field={"service"}
                      fullWidth
                      style={{ width: "48%" }}
                    />
                  </div>
                </div>
              ) : option.value === "4 PERSONS & ABOVE" ? (
                <div>
                  <h4>Select Service</h4>
                  <div
                    style={{
                      marginTop: "1%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Option
                      categories={fourPersonPremiumPackages}
                      handleData={handleData}
                      label={"4 PERSONS & ABOVE"}
                      fontStyle={styles.fontSizeOptionsStyle}
                      field={"service"}
                      fullWidth
                      style={{ width: "48%" }}
                    />
                  </div>
                </div>
              ) : option.value === "1 Session" ? (
                <div>
                  <h6>
                    ADDITIONAL PERSON 20% OFF THE SELECTED PACKAGE PER PERSON,
                    PER PACKAGE
                  </h6>
                  <h4>Select Service</h4>
                  <div
                    style={{
                      marginTop: "1%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Option
                      categories={oneSessions}
                      handleData={handleData}
                      label={"1 Session"}
                      fontStyle={styles.fontSizeOptionsStyle}
                      field={"service"}
                      fullWidth
                      style={{ width: "48%" }}
                    />
                  </div>
                </div>
              ) : option.value === "10 Sessions" ? (
                <div>
                  <h6>
                    ADDITIONAL PERSON 20% OFF THE SELECTED PACKAGE PER PERSON,
                    PER PACKAGE
                  </h6>
                  <h4>Select Service</h4>
                  <div
                    style={{
                      marginTop: "1%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Option
                      categories={tenSessions}
                      handleData={handleData}
                      label={"10 Sessions"}
                      fontStyle={styles.fontSizeOptionsStyle}
                      field={"service"}
                      fullWidth
                      style={{ width: "48%" }}
                    />
                  </div>
                </div>
              ) : option.value === "AQUA CLASS" ? (
                <div>
                  <h6>
                    ADDITIONAL PERSON 20% OFF THE SELECTED PACKAGE PER PERSON,
                    PER PACKAGE
                  </h6>
                  <h4>Select Service</h4>
                  <div
                    style={{
                      marginTop: "1%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Option
                      categories={aquSessions}
                      handleData={handleData}
                      label={"AQUA CLASS"}
                      fontStyle={styles.fontSizeOptionsStyle}
                      field={"service"}
                      fullWidth
                      style={{ width: "48%" }}
                    />
                  </div>
                </div>
              ) : option.value === "10 AQUA CLASSES" ? (
                <div>
                  <h6>
                    ADDITIONAL PERSON 20% OFF THE SELECTED PACKAGE PER PERSON,
                    PER PACKAGE
                  </h6>
                  <h4>Select Service</h4>
                  <div
                    style={{
                      marginTop: "1%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Option
                      categories={aquTenSessions}
                      handleData={handleData}
                      label={"10 AQUA CLASSES"}
                      fontStyle={styles.fontSizeOptionsStyle}
                      field={"service"}
                      fullWidth
                      style={{ width: "48%" }}
                    />
                  </div>
                </div>
              ) : null}
              {/* </div> */}
              <div
                style={{
                  marginTop: "1.5%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <h3
                  style={{
                    fontFamily: "Nunito",
                    fontSize: "1.1em",
                    opacity: 0.3,
                  }}
                >
                  Total
                </h3>
                <h3
                  style={{
                    fontFamily: "Nunito",
                    fontSize: "1.1em",
                    // opacity: 0.3,
                  }}
                >
                  {`${totalAmount} QAR`}
                </h3>
              </div>
            </div>

            <div
              style={{
                // height: windowDimensions.height / 3,
                display: "flex",
                flex: 1,
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div style={{ width: "90%", padding: "2%" }}>
                {clicked ? (
                  <LoadingButton
                    loading
                    variant="outlined"
                    style={
                      windowDimensions.width < 1000
                        ? styles.mobileButton
                        : styles.desktopButton
                    }
                  >
                    SUBMIT
                  </LoadingButton>
                ) : (
                  <ColorButton
                    onClick={() => pay()}
                    style={
                      windowDimensions.width < 1000
                        ? styles.mobileButton
                        : styles.desktopButton
                    }
                  >
                    Proceed to Pay
                  </ColorButton>
                )}
              </div>

              {/* <h1>hello</h1> */}
            </div>
            <div
              style={{
                // padding: "5%",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",
              }}
            >
              <img
                src={skip}
                style={
                  windowDimensions.width < 1000
                    ? { height: windowDimensions.width / 8 }
                    : { height: windowDimensions.width / 25 }
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
